var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollections(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.833 6.25h10.834c.46 0 .833.433.833.968v11.915a.5.5 0 01-.75.433L6.45 16.498a.5.5 0 00-.504.002L.754 19.557A.5.5 0 010 19.126V7.218c0-.535.373-.968.833-.968z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.114V4.718c0-.535-.373-.968-.833-.968H8.333c-.833 0-.833-.535-.833-1.227V.968C7.5.433 7.873 0 8.333 0h10.834c.46 0 .833.433.833.968v13.01a.5.5 0 01-.807.395L15 11.113z"
  })));
}
export default SvgCollections;